<template>
  <div class="container">
    <div class="forms-container">
      <div class="img_container">
        <img src="../assets/logo.png" style="width: 100%;height: 100%;position: absolute;top: 0;left: 0;" />
      </div>
      <div class="signin-signup">
        <form action="#" class="sign-up-form">
          <h2 class="title" v-show="false">忘记密码</h2>
          <div class="input-field">
            <van-icon name="question-o"  color="#4481eb"/>
            <input type="text" v-model="registerUserForm.userName" placeholder="请输入重置密码账号"  style="color: black;">
            <button  @click.prevent="queryQuestion" style="position: absolute;top: 28px;right: 12%;border: 0 solid;background-color: transparent;">获取问题</button>
          </div>
          <div class="input-field">
            <van-icon name="question-o"  color="#4481eb"/>
            <input type="text" v-model="questions" placeholder="你的小学学校名字？" disabled style="color: black;">
          </div>
          <div class="input-field">
            <van-icon name="orders-o" color="#4481eb"/>
            <div class="verify-input">
              <input type="text" v-model="registerUserForm.userAnswer" placeholder="输入答案" style="width: 65%;">
              <!-- <div style="margin: auto 0;">
                <van-button id="verifyCode" type="info" @click.prevent="queryVerifyCode" size="small" class="code-input":disabled="isAreadSend"><span v-show="isAreadSend">{{ timeCount }}</span><span v-show="!isAreadSend">获取验证码</span></van-button>
              </div> -->
            </div>
          </div>
          <div class="input-field">
            <van-icon name="closed-eye" color="#4481eb"/>
            <input type="password" v-model="registerUserForm.userPassword" placeholder="密码">
          </div>
          <div class="input-field">
            <van-icon name="closed-eye" color="#4481eb"/>
            <input type="password" v-model="registerUserForm.conformPassword" placeholder="确认密码">
          </div>
          <div v-show="registerUserForm.errorVisible" style="color: #cccccc">
            {{ registerUserForm.errorMsg }}
          </div>
          <input type="button" @click="userRegister" value="确认找回" class="btn solid">
          <div style="color: #4481eb;font-size: 14px">
            <el-row :gutter="20" style="margin-top: 1%;">
              <el-col :span="24" :offset="10">
                <span >还未注册账号,</span><el-button type="text" @click="goToRegister">立即注册</el-button>
              </el-col>
            </el-row>
          </div>
        </form>
      </div>
    </div>
    <van-dialog
        title="修改成功"
        v-model="registDialogVisible"
        width="30%"
        center>
      <span>修改密码成功， 请选择对应客户端登录</span>
      <span slot="footer" class="dialog-footer">
         <van-button @click="registDialogVisible = false">知道了</van-button>
      </span>
    </van-dialog>
  </div>
</template>

<script>
import {querySmsTime, resetPassword, sendSmsForgetPwd, queryUserQuestion} from "../api/system/sys_user";
import {MessageBox} from "mint-ui";
import {Toast} from "vant"

export default {
name: "ForgetPassword",
  data(){
  return {
    isAreadSend: false,
    registDialogVisible:false,
    questions: null,
    registerUserForm:{
      answer: ""
    },
    timeCount: 300,
    loginbg: require('@/assets/img/bglogin.jpeg'),
  }
  },
  mounted() {
    const container = document.querySelector(".container");

    container.classList.add("sign-up-mode");
    querySmsTime().then(res=>{
      if (res.success){
        this.timeCount = res.data;
      }
    });
  },
  methods:{
    queryQuestion(){
      //修改密码问题
    queryUserQuestion(this.registerUserForm.userName).then((res)=>{
      if (res.success){
        console.log(res.data)
        this.questions = res.data.userQuestion;
      }
    })
    },
    userRegister(){
      if (this.registerUserForm.userPassword !== this.registerUserForm.conformPassword){
        this.registerUserForm.errorMsg = "两次输入密码不一致！"
        this.registerUserForm.errorVisible = true;
      }else{
        let roleCode = "customer";
        if (window.location.hostname == "zb.taoxibao.fit" ||window.location.pathname == "/author"){
          roleCode = "anchor";
        }
        this.registerUserForm.roleCode = roleCode;
        resetPassword(this.registerUserForm).then(res=>{
          if (res.success){
            //this.$message.success("修改成功")
            MessageBox({
              title: '提示',
              message: "修改成功",
              showCancelButton: true
            });
            this.$router.push({name:'login'});
          }
        });
      }
    },
    goToRegister(){
      this.$router.push({name:'register'});
    },
    queryVerifyCode(){
      if (this.registerUserForm.userPhone == null){
        this.registerUserForm.errorMsg = "请输入手机号！"
        this.registerUserForm.errorVisible = true;
      }
      let that = this;
      let t;
      sendSmsForgetPwd(this.registerUserForm.userPhone).then(res=>{
        if (res.success){
          Toast.success("短信发送成功");
          //let timeCount1 = that.timeCount;
          //let val = document.getElementById("verifyCode");
          this.isAreadSend = true;
          t = setInterval(()=>{
            if (that.timeCount >  0){
              --that.timeCount;
              //val.value = timeCount1;
            }else{
              val.value = "获取验证码";
              that.timeCount = 300
              this.isAreadSend = false;
              clearInterval(t);
            }
          }, 1000);
        }
      }).catch(err => {
        //this.$message({message: err.message, type: 'error'});
        MessageBox({
          title: '提示',
          message: err.message,
          showCancelButton: true
        });
        clearInterval(t);
      });
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
/* google字体库 */
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200;300;400;500;600;700;800&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container{
    min-height: 800px;
    min-height: 100dvh;
    width: 100%;
    // background: linear-gradient(
    //   115deg,
    //   rgb(103, 208, 122) 0,
    //   rgb(79, 79, 216) 100%
    // );
    background-color: #fff;
    background-image: url(../assets/img/loginbg.png);
    background-repeat: no-repeat;
    background-size: contain;
}

.container::before {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  /*
  border-radius: 50%;
  background: linear-gradient(-45deg, #4481eb, #04befe);
  top: -10%;
  right: 48%;
  transform: translateY(-50%);
  */
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0, 0, 0, .3);
  z-index: 4;
  transition: 1.8s ease-in-out;
}

.forms-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

}

.signin-signup {
  position: absolute;
  top: 50%;
  left: 75%;
  /* 作用是什么 */
  transform: translate(-50%, -50%);
  width: 50%;
  display: grid;
  grid-template-columns: 1fr;
  z-index: 6;
  transition: 1s 0.7s ease-in-out;
}

form {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 0 5rem;
  overflow: hidden;
  /* 难点 */
  grid-column: 1 / 2;
  grid-row: 1 / 2;

  /* delay防止表单提前暴露 */
  transition: 0.2s 0.7s ease-in-out;
}

form.sign-in-form {
  z-index: 2;
}

form.sign-up-form {
  z-index: 1;
  opacity: 0;
}

.title {
  font-size: 2.2rem;
  color: #ffffff;
  margin-bottom: 10px;
}

.input-field {
  max-width: 300px;
  width: 100%;
  height: 55px;
  // background-color: #f0f0f0;
  margin: 10px 0;
  border-radius: 0px;
  display: grid;
  grid-template-columns: 8.2% 85%;
  // padding: 0 0.4rem;
  border-bottom: 1px solid #d7d0d0;
}

.verify-input{
  display: inline-grid;
  grid-template-columns: repeat(2,auto);;
  .code-input{
    position: relative;
  }
}

.input-field select {
  background: none;
  outline: none;
  border: none;
  line-height: 1;
  font-weight: 600;
  font-size: 1.1rem;
  color: #aaa;
}

.input-field i {
  text-align: center;
  line-height: 55px;
  color: #acacac;
  font-size: 1.1rem;
}

.input-field input {
  background: none;
  outline: none;
  border: none;
  line-height: 1;
  font-weight: 600;
  font-size: 1.1rem;
  color: #333;
}

.input-field input::placeholder {
  color: #aaa;
  font-weight: 500;
}

.btn {
  width: 300px;
  height: 40px;
  border: none;
  outline: none;
  border-radius: 45px;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(to right, #3333ff, #3392ff);
  /* 大写 */
  text-transform: uppercase;
  font-weight: 600;
  margin: 10px 0;
  /* 动画延迟 */
  transition: .5s;
}

.btn:hover {
  background-color: #4d84e2;
}

.social-text {
  padding: .7rem 0;
  font-size: 1rem;
}

.social-media {
  display: flex;
  justify-content: center;
}

.social-icon {
  height: 40px;
  width: 40px;
  border: 1px solid #333;
  margin: 0 0.45rem;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  color: #333;
  font-size: 1.1rem;
  border-radius: 50%;
  transition: 0.3s;
}

.social-icon:hover {
  color: #4481eb;
  border-color: #44b1eb;
}

.panels-container {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}

.panel {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: center;
  justify-content: center;
  z-index: 7;
}

.panel .content {
  color: #fff;
  transition: .9s .6s ease-in-out;
}

.panel h3 {
  font-weight: 600;
  line-height: 1;
  font-size: 1.5rem;
}

.panel p {
  font-size: 0.95rem;
  padding: 0.7rem 0;
}

.btn.transparent {
  margin: 0;
  background: none;
  border: 2px solid #fff;
  width: 130px;
  height: 41px;
  font-weight: 600;
  font-size: 0.8rem;
}

.left-panel {
  pointer-events: all;
  padding: 3rem 17% 2rem 12%;
}

.right-panel {
  pointer-events: none;
  padding: 3rem 12% 2rem 17%;
}

.image {
  width: 100%;
  transition: 1.1s .4s ease-in-out;
}

.right-panel .content, .right-panel .image {
  transform: translateX(800px);
}

.container.sign-up-mode:before {
  /* transform: translate(100%, -50%);
   right: 52%;

   */
}

.container.sign-up-mode .left-panel .image,
.container.sign-up-mode .left-panel .content {
  transform: translateX(-800px);
}

.container.sign-up-mode .right-panel .content,
.container.sign-up-mode .right-panel .image {
  transform: translateX(0px);
}

.container.sign-up-mode .left-panel {
  pointer-events: none;
}

.container.sign-up-mode .right-panel {
  pointer-events: all;
}

.container.sign-up-mode .signin-signup {
  /*left: 25%;*/
}

.container.sign-up-mode form.sign-in-form {
  z-index: 1;
  opacity: 0;
}

.container.sign-up-mode form.sign-up-form {
  z-index: 2;
  opacity: 1;
}

@media(max-width: 870px) {

  .container:before {
    width: 100%;
    height: 100%;
    z-index: -1;
  }

  .signin-signup {
    width: 100%;
  }

  .panels-container {

    z-index: 10;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 2fr 1fr;
  }

  .panel {
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
    padding: 2.5rem 8%;
  }

  .image {
    width: 200px;
    transition: 0.9s 0.6s ease-in-out;
  }

  .left-panel {
    grid-row: 1 / 2;
  }

  .right-panel {
    grid-row: 3 / 4;
  }

  .panel h3 {
    font-size: 1.2rem;
  }

  .panel p {
    font-size: 0.7rem;
    padding: 0.5rem 0;
  }

  .btn.btn.transparent {
    width: 110px;
    height: 35px;
    font-variation-settings: 0.7rem;
  }

  .panel .content {
    padding-right: 15%;
    transition: 0.9s 0.8s ease-in-out;
  }

  .right-panel .content, .right-panel .image {
    transform: translateY(300px);
  }

  .container.sign-up-mode:before {
    transform: translate(-50%, 100%);
    bottom: 32%;
    right: initial;
  }

  .container.sign-up-mode .left-panel .image,
  .container.sign-up-mode .left-panel .content {
    transform: translateY(-300px);
  }

  .container.sign-up-mode .signin-signup {
    top: 30%;
    transform: translate(-50%, 0);
    left: 50%;
  }
}

@media (max-width: 465px) {
  form {
    padding: 0 1.5rem;
  }

  .image {
    display: none;
  }

  .container .left-panel .content,
  .container .right-panel .content {
    margin-left: 40px;
  }

}

  .img_container {
    width: 64px;
    height: 64px;
    padding: 12%;
    margin: 0;
    border-radius: 105px;
    background-color: #fff;
    position: relative;
    top: 5%;
    left: 38%;
    box-shadow: 1px 4px 5px 0px rgba(97, 121, 156, 0.75);
    overflow: hidden;
  }
</style>
